export class Form {
    formElement;
    submitElements;
    options;
    errorAlertEl;
    static defaultOptions = {
        targetUrl: '/hatchery/api/form/submit',
        errorAlertEl: '.form-error-alert',
        transformData(formData) {
            return formData;
        },
        onSuccess: responseData => {
            if (responseData.redirect) {
                window.location.href = responseData.redirect;
            }
        },
        onError: err => console.error(err),
    };
    constructor(formElement, options) {
        // In case they passed in a string, try to search for that string
        if (typeof formElement === 'string') {
            if (!formElement) {
                throw new Error(`Failed to find an element using the selector '${formElement}'.`);
            }
            const foundElement = document.querySelector(formElement);
            if (!(foundElement instanceof HTMLFormElement)) {
                throw new Error(`Found element is not a form element.`);
            }
            formElement = foundElement;
        }
        else if (!(formElement instanceof HTMLFormElement)) {
            throw new Error(`Invalid HTMLElement provided: '${formElement}'.`);
        }
        // Make reference to form element public
        this.formElement = formElement;
        // Make reference to submit element
        this.submitElements = formElement.querySelectorAll('[type="submit"]');
        // Apply options
        this.options = Object.assign({ ...Form.defaultOptions }, options);
        // Verify that the error alert element is valid
        if (this.options.errorAlertEl) {
            // Make sure we either have a selector string or an HTMLElement reference
            let domElement = typeof this.options.errorAlertEl === 'string'
                ? document.querySelector(this.options.errorAlertEl)
                : this.options.errorAlertEl;
            if (!domElement || !(domElement instanceof HTMLElement)) {
                throw new Error(`Invalid HTMLElement for error alert element provided: '${domElement?.tagName}'.`);
            }
            else if (this.options.errorAlertEl.hasOwnProperty('innerText')) {
                throw new Error(`Provided error alert element does not have required property \`.innerText\`: '${this.options.errorAlertEl}'.`);
            }
            else {
                this.errorAlertEl = domElement;
            }
        }
        // Verify callback functions
        const callbackFunctions = ['onSuccess', 'onError', 'transformData'];
        callbackFunctions.forEach(callbackName => {
            if (this.options[callbackName] && typeof this.options[callbackName] !== 'function') {
                throw new Error(`Callback function "${callbackName}" is not a function.`);
            }
        });
        this.attachListener();
    }
    attachListener() {
        this.formElement.addEventListener('submit', e => {
            e.preventDefault();
            // Parse form values into FormData
            let formData = new FormData(this.formElement);
            // Transform the values
            // @ts-ignore
            formData = this.options.transformData(formData);
            // Apply custom page_id if provided
            if (this.options.pageId) {
                formData.set('page_id', this.options.pageId);
            }
            // Add loading and submitting classes to form elements
            this.formElement.classList.add('is-submitting');
            this.submitElements.forEach(el => el.classList.add('is-loading'));
            // Send them to our API endpoint
            fetch(this.options.apiEndPoint ?? this.options.targetUrl, {
                body: formData,
                method: 'POST',
            })
                .then(response => {
                response
                    .json()
                    .then(data => {
                    if (!response.ok) {
                        throw new Error(data.message);
                    }
                    // The form went through successfully
                    // If there's an error alert box, empty it again
                    if (this.errorAlertEl) {
                        this.errorAlertEl.innerHTML = '';
                    }
                    // Run success callback
                    // @ts-ignore
                    this.options.onSuccess(data);
                })
                    .catch(error => {
                    // If there's an error alert element, show the error message to the user
                    if (this.errorAlertEl) {
                        this.errorAlertEl.innerHTML = error.message;
                    }
                    // Run error callback, if it exists
                    if (this.options.onError) {
                        this.options.onError(error);
                    }
                })
                    .finally(() => {
                    this.formElement.classList.remove('is-submitting');
                    this.submitElements.forEach(el => el.classList.remove('is-loading'));
                });
            })
                .catch(console.error);
        });
    }
}
